import React, { Component } from 'react'
import ReactTable from 'react-table';
import { getCategoriesV2List, createNewSubcategory, removeSubcategory, getOneCategoryV2, updateSubcategory } from '../../modules/Api';
import { notification, Button } from 'antd';
import SubcategoryModal from '../../components/Category';
import history from '../../modules/History';
import { btnStyle, getSliderRouteParams } from './common';

class Subcategories extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 15,
            count: 0,
            last_page: 1,
            visibleModal: false,
            formData: {}
        }
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        const filter = {
            parent_id: id,
        }

        this.fetchData('filter='+JSON.stringify(filter));
    }

    fetchData = (query = '') => {
        getCategoriesV2List(query, (data) => {this.setState({
            items: data.data,
            last_page: data.last_page,
            count: data.total,
            pageSize: data.per_page
        })});
    }

    onChange = (state) => {
        this.setState({pageSize: parseInt(state.pageSize, 10)});
        let sort = {
            order: 'desc',
            field: 'id',
        };
        if(state.sorted.length > 0) {
            sort = {
                order: state.sorted[0].desc ? 'desc': 'asc',
                field: state.sorted[0].id,
            }
        }

        const id = this.props.match.params.id;
        const filter = {
            parent_id: id,
            title: state.filtered.find(f => f.id === 'name') ? state.filtered.find(f => f.id === 'name').value : '',
        }
        const query = `page=${state.page  + 1}&perPage=${state.pageSize}&filter=${JSON.stringify(filter)}&sort=${JSON.stringify(sort)}`;

        this.fetchData(query);
    }

    deleteSubcategory = id => {
        let that = this;
        removeSubcategory(id, function(){
            notification.open({message: 'حذف شد.'});
            // reload
            const id = that.props.match.params.id;
            const filter = {
                parent_id: id,
            }

            that.fetchData('filter='+JSON.stringify(filter));
        })
    }

    editSubcategory = id => {
        let that = this;
        getOneCategoryV2(id, function(data){
            that.setState({
                formData: {
                    title: data.name,
                    id: data.id,
                    meta_title: data.meta_title,
                    meta_description: data.meta_description,
                    images: data.images,
                    description: data.description,
                    image: data.image,
                }
            })
            that.openModal()
        })

    }

    openModal() {
        this.setState({visibleModal: true});
    }

    commitModalChanges(data) {
        let that = this;
        notification.open({message: `اطلاعات در حال ارسال است . لطفا منتظر بمانید ...`});
        if(data.id) {
            updateSubcategory(data.id,{...data, ...{parent_id: this.props.match.params.id}}, (data) => {
                notification.open({message: data.message});

                // reload
                const id = that.props.match.params.id;
                const filter = {
                    parent_id: id,
                }

                that.fetchData('filter='+JSON.stringify(filter));
            }).catch(function(error){
                notification.error({message:
                    error.response.data.data ?
                        error.response.data.data.name
                            ? error.response.data.data.name[0]
                            : error.response.data.data.images ? error.response.data.data.images[0] : 'اطلاعات نامعتبر'
                    : ''
                });
            });
        }else {
            createNewSubcategory({...data, ...{parent_id: this.props.match.params.id}}, (data) => {
                notification.open({message: data.message});

                // reload
                const id = that.props.match.params.id;
                const filter = {
                    parent_id: id,
                }

                that.fetchData('filter='+JSON.stringify(filter));
            }).catch(function(error){
                notification.error({message:
                    error.response.data.data.name
                        ? error.response.data.data.name[0]
                        : error.response.data.data.images ? error.response.data.data.images[0] : 'اطلاعات نامعتبر'
                });
            });
        }

        this.closeModal();
    }

    closeModal() {
        this.setState({visibleModal: false, formData: {
            title: '',
            id: undefined,
            images: []
        }});
    }

    createSub () {
        this.setState({visibleModal: true, formData: {
            title: '',
            id: undefined,
            images: []
        }});
    }

    render() {
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id',
            },
            {
                Header: 'عنوان',
                accessor: 'title',
                filterable: true,
                Cell: row => (<span title={row.original.name}> {row.original.name} </span>)
            },
            {
                Header: 'ویرایش',
                accessor: 'edit',
                Cell: (row) => <span style={{...btnStyle, backgroundColor: '#0066ff'}} onClick={() => {this.editSubcategory(row.original.id)}}>ویرایش</span>,
                style:{textAlign:'center'}
            },
            {
                Header: 'تاریخچه',
                accessor: 'history',
                Cell: (row) => <span style={{...btnStyle, color: '#0066ff'}} onClick={() => {history.item.push(`/history/category/${row.original.id}`)}}>تاریخچه</span>,
                style:{textAlign:'center'}
            },
            {
                Header: 'اسلایدر',
                accessor: 'sliders',
                style:{textAlign:'center'},
                Cell: (row) =>
                    <React.Fragment>
                        <span style={{...btnStyle, backgroundColor: '#066'}} onClick={() => {history.item.push(getSliderRouteParams(row))}}>سایت</span>
                        <span style={{...btnStyle, backgroundColor: '#606'}} onClick={() => {history.item.push(getSliderRouteParams(row, true))}}>اپ</span>
                    </React.Fragment>
            },
            {
                Header: 'حذف',
                accessor: 'delete',
                Cell: (row) => <span style={{...btnStyle, backgroundColor: '#ff0079'}} onClick={() => {this.deleteSubcategory(row.original.id)}}>حذف</span>,
                style:{textAlign:'center'}
            }
        ]
        return(
            <div style={{textAlign: 'center'}}>
                <div className="btn-container">
                    <Button
                        type="primary"
                        htmlType="button"
                        onClick={this.createSub.bind(this)}>
                        زیردسته جدید
                    </Button>

                    <Button type="secondary" onClick={() => history.item.push(`/history/category`)}>تاریخچه تغییرات</Button>
                </div>
                <SubcategoryModal
                    initialData={this.state.formData}
                    visible={this.state.visibleModal}
                    open={this.openModal.bind(this)}
                    close={this.closeModal.bind(this)}
                    commit={this.commitModalChanges.bind(this)}/>
                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={state => this.onChange(state)}
                    defaultPageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}

export default Subcategories;



// WEBPACK FOOTER //
// ./src/containers/Categories/subcategories.js